/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Wallet
 */
export interface Wallet {
    /**
     * User's email.
     * @type {string}
     * @memberof Wallet
     */
    email: string;
    /**
     * Wallet data was returned from Keria. It is used to call keria boot
     * @type {string}
     * @memberof Wallet
     */
    walletData: string;
}

/**
 * Check if a given object implements the Wallet interface.
 */
export function instanceOfWallet(value: object): boolean {
    if (!('email' in value)) return false;
    if (!('walletData' in value)) return false;
    return true;
}

export function WalletFromJSON(json: any): Wallet {
    return WalletFromJSONTyped(json, false);
}

export function WalletFromJSONTyped(json: any, ignoreDiscriminator: boolean): Wallet {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'walletData': json['walletData'],
    };
}

export function WalletToJSON(value?: Wallet | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'walletData': value['walletData'],
    };
}

